<template>
  <div>
    <!-- Reject Invoice Tally Summary Section Start -->

    <b-row>
      <b-col md="4">
        <model-list-select
          :list="feedbackList"
          v-model="reason"
          option-value="feedbackVal"
          option-text="feedbackTxt"
        ></model-list-select>
      </b-col>
      <b-col md="4" v-if="reason && RTBI_InvBtnRejection_btnFlag">
        <b-form-textarea
          v-if="reason && RTBI_InvBtnRejection_btnFlag"
          :formatter="capitalizeAll"
          rows="2"
          id="capitalizeAll"
          v-model="feedback"
          placeholder="Please Enter Invoice Rejection Reason"
        ></b-form-textarea>
      </b-col>
      <b-col md="2">
        <b-button
          :disabled="!reason || !RTBI_InvBtnRejection_btnFlag ? true : false"
          style="font-size: 0.675rem"
          class="mt-2"
          size="xs"
          @click="removeTallyInvData()"
          :variant="!reason || !RTBI_InvBtnRejection_btnFlag ? '' : 'info'"
        >
          <b
            >Reject Invoices<b-spinner
              v-if="RejectBtnName != 'Reject Invoices'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b>
        </b-button>
      </b-col>
    </b-row>

    <!-- Reject Invoice Tally Summary Section End -->

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";

export default {
  props: {
    RTBI_title: {
      type: String,
      default: "",
    },
    RTBI_JOBID: {
      type: String,
      default: "",
    },
    RTBI_JOBNO: {
      type: String,
      default: "",
    },
    RTBI_JOBDATE: {
      type: String,
      default: "",
    },
    RTBI_JOBTYPE: {
      type: String,
      default: "",
    },
    RTBI_Selected_JOBTYPE: {
      type: Array,
      default: [],
    },

    RTBI_IS_Consolidation: {
      type: String,
      default: "",
    },
    RTBI_IS_Misc: {
      type: String,
      default: "",
    },
    RTBI_Client: {
      type: String,
      default: "",
    },
    RTBI_clientId: {
      type: String,
      default: "",
    },
    RTBI_Sline: {
      type: String,
      default: "",
    },
    RTBI_ffInvoiceModal: {
      type: Object,
      default: {},
    },
    RTBI_showSegmentArray: {
      type: Array,
      default: [],
    },
    RTBI_InvBtnRejection_btnFlag: {
      type: Boolean,
      default: false,
    },
    RTBI_InvTallyId: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    if (this.RTBI_JOBID) {
      // this.getPLInvExp();
      console.log("RTBI_ffInvoiceModal=>", this.RTBI_ffInvoiceModal);
      console.log("RTBI_showSegmentArray=>", this.RTBI_showSegmentArray);
    }
  },
  mounted() {},

  data() {
    return {
      RejectBtnName: "Reject Invoices",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      Page_title: this.RTBI_title,
      selectedOptions: [],
      allModuleId: this.RTBI_JOBID,
      isLoading: false,
      feedbackList: [
        {
          feedbackVal: "INCOMPLETE DOCUMENT",
          feedbackTxt: "INCOMPLETE DOCUMENT",
        },
        {
          feedbackVal: "INCOMPLETE BILLING DETAILS",
          feedbackTxt: "INCOMPLETE BILLING DETAILS",
        },
        // {
        //   feedbackVal: "INCOMPLETE BILLING DETAILS",
        //   feedbackTxt: "",
        // },
      ],
      reason: "",
      feedback: "",
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {},
      deep: true,
    },
  },
  methods: {
    removeTallyInvData() {
      if (this.RejectBtnName != "Reject Invoices") {
        console.log("Please Wait Processing!!!!!!");
        return false;
      }
      let payload = {
        FF: this.RTBI_Selected_JOBTYPE.indexOf("FF") >= 0 ? 1 : 0,
        CC: this.RTBI_Selected_JOBTYPE.indexOf("CC") >= 0 ? 1 : 0,
        TPT: this.RTBI_Selected_JOBTYPE.indexOf("TPT") >= 0 ? 1 : 0,
        MISC: this.RTBI_Selected_JOBTYPE.indexOf("MISC") >= 0 ? 1 : 0,
        IB: this.RTBI_Selected_JOBTYPE.indexOf("IB") >= 0 ? 1 : 0,
        YARD: this.RTBI_Selected_JOBTYPE.indexOf("YARD") >= 0 ? 1 : 0,
        Selected_JOBTYPE: this.RTBI_Selected_JOBTYPE.toString(),
        JOBID: this.RTBI_JOBID,
        JOBNO: this.RTBI_JOBNO,
        itemCode: "RejectTallyInvoices",
        comment: this.reason,
        feedback: this.feedback,
        Client: this.RTBI_Client,
        clientId: this.RTBI_clientId,
        is_misc: this.RTBI_IS_Misc,
        is_consolidation: this.RTBI_IS_Consolidation,
        InvTallyId: this.RTBI_InvTallyId,
      };
      this.RejectBtnName = "Rejecting Please Wait!";
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.find == 1 && data.flag == true) {
            this.RejectBtnName = "Reject Invoices";
            this.alert.content = data.MSG;
            this.$refs["addPop"].open();
            this.$router.push({
              path: "/viewBillingDetails/viewBillingDetails",
            });
          } else {
            this.alert.content = data.MSG;
            this.$refs["addPop"].open();
          }
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },
  },
};
</script>
<style>
.checkbox-container {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-label {
  display: flex;
  align-items: center;
  margin-right: 20px;
  position: relative; /* Position relative to align the checkmark properly */
}

/* Customize the label text */
.checkbox-label input[type="checkbox"] {
  opacity: 0;
  position: absolute;
}

/* Create a custom checkbox */

/* Create a custom checkbox */
.checkmark {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 2px solid #ccc;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}

/* On mouse-over, add a grey background color */
.checkbox-label:hover .checkmark {
  border-color: #aaa;
}

/* When the checkbox is checked, add a blue border */
.checkbox-label input[type="checkbox"]:checked + .checkmark {
  border-color: #2196f3;
}

/* Style the checkmark/indicator */
.checkmark:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid transparent;
  border-right: 2px solid transparent;
  border-top: 2px solid #2196f3; /* Make the checkmark blue */
  border-left: 2px solid #2196f3; /* Make the checkmark blue */
  transform: translate(-50%, -50%) rotate(45deg); /* Center the checkmark */
  opacity: 0;
}

/* Show the checkmark when checked */
.checkbox-label input[type="checkbox"]:checked + .checkmark:after {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// rejectInvTallyBill.vue?c35c6262